import React, { useState } from 'react';
import { DiCssTricks } from 'react-icons/di';
import { MdDelete, MdEdit, MdCheck, MdClose } from 'react-icons/md';
import AddMoreBtn from '../AddMoreBtn';
import { Input } from '../Input/Input';
import { DropDown } from '../DropDown/DropDown';

import classes from './AddMultiValueInputWithDropDownContainer.module.css';

const AddMultiValueInputWithDropDownContainer = ({
  title = 'Default Title',
  dropDownoptions = [],
  dropDownValueKey = 'label',
  inputValueKey = 'value',
  inputValue,
  inputSetter,
  arrayValue,
  arraySetter,
  inputPlaceholder = 'Enter Text',
  dropDownPlaceholder = 'select value',
  type = 'text',
  disabled = false,
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState({
    [dropDownValueKey]: '',
    [inputValueKey]: '',
  });

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditValue({
      [dropDownValueKey]: arrayValue[index][dropDownValueKey],
      [inputValueKey]: arrayValue[index][inputValueKey],
    });
  };

  const handleSaveEdit = (index) => {
    if (editValue[dropDownValueKey] !== '' && editValue[inputValueKey] !== '') {
      const newArray = [...arrayValue];
      newArray[index] = {
        [dropDownValueKey]: editValue[dropDownValueKey],
        [inputValueKey]: editValue[inputValueKey],
      };
      arraySetter(newArray);
    }
    setEditingIndex(null);
    setEditValue({
      [dropDownValueKey]: '',
      [inputValueKey]: '',
    });
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditValue({
      [dropDownValueKey]: '',
      [inputValueKey]: '',
    });
  };

  const handleDelete = (index) => {
    if (disabled) return;
    let newArray = [...arrayValue];
    newArray.splice(index, 1);
    arraySetter(newArray);
  };

  console.log(arrayValue);
  return (
    <div className={classes?.mainContainer}>
      <div className={[classes?.inputAndAddBtnContainer].join(' ')}>
        <span className={classes?.titleText}>{title}</span>
        <AddMoreBtn
          onClick={() => {
            if (inputValue !== '') {
              arraySetter((pre) => [...pre, inputValue]);
              inputSetter({
                [dropDownValueKey]: '',
                [inputValueKey]: '',
              });
            }
          }}
          disabled={disabled}
        />
      </div>
      <div className={classes?.inputSection}>
        <DropDown
          disabled={disabled}
          setter={(item) => {
            inputSetter({
              ...inputValue,
              [dropDownValueKey]: item?.value,
            });
          }}
          value={
            inputValue[dropDownValueKey] !== ''
              ? {
                  label: inputValue[dropDownValueKey],
                  value: inputValue[dropDownValueKey],
                }
              : ''
          }
          placeholder={dropDownPlaceholder}
          options={dropDownoptions}
          optionLabel={'label'}
          optionValue={'value'}
        />
        <Input
          disabled={disabled}
          setter={(value) => {
            inputSetter({
              ...inputValue,
              [inputValueKey]: value,
            });
          }}
          value={inputValue[inputValueKey]}
          placeholder={inputPlaceholder}
          type={type}
        />
      </div>

      {arrayValue.map((item, index) => (
        <div
          className={[classes.bulletContainer].join(' ')}
          key={`${index} busHighlight`}
        >
          {editingIndex === index ? (
            <>
              <div className={classes.editInputSection}>
                <DropDown
                  setter={(selectedItem) => {
                    setEditValue({
                      ...editValue,
                      [dropDownValueKey]: selectedItem?.value,
                    });
                  }}
                  value={
                    editValue[dropDownValueKey] !== ''
                      ? {
                          label: editValue[dropDownValueKey],
                          value: editValue[dropDownValueKey],
                        }
                      : ''
                  }
                  placeholder={dropDownPlaceholder}
                  options={dropDownoptions}
                  optionLabel={'label'}
                  optionValue={'value'}
                />
                <Input
                  value={editValue[inputValueKey]}
                  setter={(value) => {
                    setEditValue({
                      ...editValue,
                      [inputValueKey]: value,
                    });
                  }}
                  placeholder={inputPlaceholder}
                  type={type}
                  autoFocus={true}
                />
              </div>
              <div className={classes.editActions}>
                <MdCheck
                  color={'var(--success-color, #4CAF50)'}
                  size={20}
                  onClick={() => handleSaveEdit(index)}
                  className={classes.actionIcon}
                />
                <MdClose
                  color={'var(--error-color, #f44336)'}
                  size={20}
                  onClick={handleCancelEdit}
                  className={classes.actionIcon}
                />
              </div>
            </>
          ) : (
            <>
              <span className={classes?.keySpan}>{`${item[dropDownValueKey]}:`}</span>
              <span className={classes?.valueSpan}>{item[inputValueKey]}</span>
              <div className={classes.itemActions}>
                {!disabled && (
                  <MdEdit
                    color={'var(--dashboard-main-color)'}
                    size={18}
                    onClick={() => handleEdit(index)}
                    className={classes.actionIcon}
                  />
                )}
                <MdDelete
                  color={'var(--dashboard-main-color)'}
                  size={20}
                  onClick={() => handleDelete(index)}
                  className={classes.actionIcon}
                />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AddMultiValueInputWithDropDownContainer;
